import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const PartnerWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

export const PartnerContent = styled.div`
    flex: 1 1 auto;
    max-width: 1360px;
    margin: 0 auto;
    padding: 32px 16px;
    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding: 16px 8px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 8px 4px;
    }
`;

export const PartnerAccessStyled = styled.div`
    text-align: center;
    svg {
        fill: #FFFFFF;
    }
`;
